<template>
  <div id="page-autocomplete-demo">
    <!-- AJAX BASED AUTOCOMPLETE -->
    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :list="getList"
      :max-suggestions="5"
      :min-length="1"
      :debounce="500"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27]
      }"
      :mode="mode"
      ref="suggestComponent"
      placeholder="Search contacts.."
      value-attribute="id"
      display-attribute="name"
      @select="onSuggestSelect"
      :selectedSlave="selectedSlave"
      :campaignId="campaignId"
    >
      <!-- <template v-if="combined_matches.length > 0">
        <template v-for="(accepted, index) in combined_matches">
          <div
            v-if="accepted.slave_id == selectedSlave"
            :key="index"
            class="mb-5"
          >
            <h6>Accepted :</h6>

            <p>{{ accepted.contact_name }}</p>
          </div>
        </template>
      </template> -->
      <div class="g">
        <input type="text" placeholder="Search contacts" />
      </div>

      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div class="misc-item">
          <span>You're searching for '{{ query }}'.</span>
        </div>

        <template v-if="suggestions.length > 0">
          <!-- <div class="misc-item">
              <span>{{ suggestions.length }} suggestions are shown...</span>
            </div> -->
          <hr />
        </template>

        <div class="misc-item" v-else-if="!loading">
          <span>No results</span>
        </div>
      </template>

      <div
        slot="suggestion-item"
        slot-scope="scope"
        :title="scope.suggestion.name"
      >
        <div class="flex mb-4">
          <!-- <div class="w-1/6 bg-grid-color h-12">
            <vs-checkbox
              class="select-checkbox"
              v-model="selectCheckbox"
              :vs-value="scope.suggestion.id"
              v-on:change="onSuggestSelect(scope.suggestion)"
            ></vs-checkbox>
          </div> -->
          <div class="w-5/6 bg-grid-color-secondary h-12">
            <div class="text">
              <span v-html="boldenSuggestion(scope)"></span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="misc-item"
        slot="misc-item-below"
        slot-scope="{ suggestions }"
        v-if="loading"
      >
        <span>Loading...</span>
      </div>
    </vue-simple-suggest>

    <!-- /AJAX BASED AUTOCOMPLETE -->
    <template v-if="selected">
      <vs-popup
        title="Database/Import Contact"
        :active.sync="popupActive"
        fullscreen
      >


        <div class="vx-row">
          <div class="flex justify-between flex-wrap fixedButtons">
            <vs-button
              class="mb-4 mr-6"
              @click="
                acceptMatch(
                  contactDescription.contact_id,
                  unmatched_contact.id,
                    contactDescription.forename +
                    ' ' +
                    contactDescription.surname
                )
              "
              type="border"
              >Accept</vs-button
            >

            <!-- <template v-if="combined_matches.length > 0">
              <template v-for="(accepted, index) in combined_matches">
                <template
                  v-if="accepted.slave_id == selectedSlave"
                  class="mb-5"
                >
                  <vs-button
                    :key="index"
                    class="mb-4"
                    type="border"
                    @click="
                      rejectMatch(
                        contactDescription.id,
                        unmatched_contact.id,
                        contactDescription.contact_name
                      )
                    "
                    color="primary"
                    >Reject</vs-button
                  >
                </template>
              </template>
            </template> -->
          </div>
          <div class="flex mb-4">
            <div class="w-1/2 bg-grid-color-secondary h-12">
              <div class="detailPopUp">
                <vs-list style="height: 245px;">
                  <h3><u>Database Record</u></h3>
                  <vs-list-header
                    title="Key Contact Details"
                    color="danger"
                  ></vs-list-header>
                  <vs-list-item title="Company Name">
                    {{ contactDescription.company_name }}
                  </vs-list-item>

                  <vs-list-item title="Title" v-if="contactDescription.title">
                    {{ contactDescription.title }}
                  </vs-list-item>
                  <vs-list-item
                    title="Forename"
                    v-if="contactDescription.forename"
                  >
                    {{ contactDescription.forename }}
                  </vs-list-item>
                  <vs-list-item
                    title="Surname"
                    v-if="contactDescription.surname"
                  >
                    {{ contactDescription.surname }}
                  </vs-list-item>



     <vs-list-item title="DDI" v-if="contactDescription.ddi">
                    <div
                      class="p-5"
                      v-for="(ddi, ddi_key) in contactDescription.ddi"
                      :key="ddi_key"
                    >
                      <span class="p-5">
                        {{ ddi.ddi_phone_code }}{{ ddi.ddi }}
                      </span>
                    </div>
                  </vs-list-item>

                  <!-- <vs-list-item title="DDI" v-if="contactDescription.ddi">
                    {{ contactDescription.ddi }}
                  </vs-list-item> -->
                  <vs-list-item title="Email" v-if="contactDescription.email">
                    <div
                      v-for="(email, email_key) in contactDescription.email"
                      :key="email_key"
                    >
                      <span>
                        {{ email.email }}
                      </span>
                    </div>
                  </vs-list-item>
                  <vs-list-item
                    title="Job Title"
                    v-if="contactDescription.job_title"
                  >
                    <div
                      v-for="(job,
                      job_title_key) in contactDescription.job_title"
                      :key="job_title_key"
                    >
                      <span>
                        <p>{{ job.job_title }}</p>
                      </span>
                    </div>
                  </vs-list-item>
                  <vs-list-item title="Mobile" v-if="contactDescription.mobile">
                    <div
                      class="p-5"
                      v-for="(mobile, mobile_key) in contactDescription.mobile"
                      :key="mobile_key"
                    >
                      <span class="p-5">
                        {{ mobile.mobile_phone_code }}{{ mobile.mobile }}
                      </span>
                    </div>
                  </vs-list-item>
                  <vs-list-item
                    title="Social Media"
                    v-if="contactDescription.social_media"
                  >
                    <div
                      v-for="(social_media,
                      social_media_key) in contactDescription.social_media"
                      :key="social_media_key"
                    >
                      <span class="p-5">
                        {{ social_media.social_media }}
                      </span>
                    </div>
                  </vs-list-item>
                  <vs-list-item
                    title="Seniority"
                    v-if="contactDescription.seniority"
                  >
                    <div
                      v-for="(senio,
                      seniority_key) in contactDescription.seniority"
                      :key="seniority_key"
                    >
                      <span>
                        <p>{{ senio.seniority }}</p>
                      </span>
                    </div>
                  </vs-list-item>
                  <vs-list-item title="Role" v-if="contactDescription.role">
                    <div
                      v-for="(r, role_key) in contactDescription.role"
                      :key="role_key"
                    >
                      <span>
                        <p>{{ r.role }}</p>
                      </span>
                    </div>
                  </vs-list-item>
                  <vs-list-item
                    title="Sub ROle"
                    v-if="contactDescription.sub_role"
                  >
                    <div
                      v-for="(sr, sr_key) in contactDescription.sub_role"
                      :key="sr_key"
                    >
                      <span>
                        <p>{{ sr.sub_role }}</p>
                      </span>
                    </div>
                  </vs-list-item>
                </vs-list>
              </div>
            </div>
            <div class="w-1/2 bg-grid-color h-12">
              <div class="detailPopUp" v-if="contactDescription.slave">
                <vs-list style="height: 245px;">
                  <h3><u>Import Record</u></h3>
                  <vs-list-header
                    title="Key Contact Details"
                    color="danger"
                  ></vs-list-header>
                  <vs-list-item title="Company Name ">
                    {{ contactDescription.slave.ml_company }}
                  </vs-list-item>
                  <vs-list-item
                    title="Title"
                    v-if="contactDescription.slave.ml_title"
                  >
                    {{ contactDescription.slave.ml_title }}
                  </vs-list-item>
                  <vs-list-item
                    title="Forename"
                    v-if="contactDescription.slave.ml_forename"
                  >
                    {{ contactDescription.slave.ml_forename }}
                  </vs-list-item>
                  <vs-list-item
                    title="Surname"
                    v-if="contactDescription.slave.ml_surname"
                  >
                    {{ contactDescription.slave.ml_surname }}
                  </vs-list-item>
                  <vs-list-item title="DDI" v-if="contactDescription.slave.ml_ddi">
                    {{ contactDescription.slave.ml_ddi }}
                  </vs-list-item>
                  <vs-list-item
                    title="Email"
                    v-if="contactDescription.slave.ml_email"
                  >
                    {{ contactDescription.slave.ml_email }}
                  </vs-list-item>
                  <vs-list-item
                    title="Job Title"
                    v-if="contactDescription.slave.ml_job_title"
                  >
                    {{ contactDescription.slave.ml_job_title }}
                  </vs-list-item>
                  <vs-list-item
                    title="Mobile"
                    v-if="contactDescription.slave.ml_mobile"
                  >
                    {{ contactDescription.slave.ml_mobile }}
                  </vs-list-item>
                  <vs-list-item
                    title="Social Media"
                    v-if="contactDescription.slave.ml_social_media"
                  >
                    {{ contactDescription.slave.ml_social_media }}
                  </vs-list-item>
                  <vs-list-item
                    title="Seniority"
                    v-if="contactDescription.slave.ml_seniority"
                  >
                    {{ contactDescription.slave.ml_seniority }}
                  </vs-list-item>
                  <vs-list-item
                    title="Role"
                    v-if="contactDescription.slave.ml_role"
                  >
                    {{ contactDescription.slave.ml_role }}
                  </vs-list-item>
                  <vs-list-item
                    title="Sub ROle"
                    v-if="contactDescription.slave.ml_sub_role"
                  >
                    {{ contactDescription.slave.ml_sub_role }}
                  </vs-list-item>
                </vs-list>
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </template>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import Prism from "vue-prism-component";
import axios from "@/axios.js";

export default {
  name: "UnmatchedContactAutocomplete",
  props: {
    unmatched_contact: Object,
    selectedSlave: Number,
    campaignId: String,
    combined_matches: Array
  },
  data() {
    return {
      chosen: null,
      selected: null,
      model: null,
      mode: "input",
      loading: false,
      log: [],
      selectCheckbox: [],
      search_result: [],
      popupActive: false,
      contactDescription: [],
      accepted_ids: [],
      selection: []
    };
  },
  methods: {
    acceptMatch(master_id, slave_id, contact_name) {
      if (this.selection.length > 0) {
        this.selection.map(element => {
          if (element.slave_id == slave_id) {
            element.master_id = master_id;
            element.contact_name = contact_name;
            return element;
          } else {
            this.selection.push({
              master_id: master_id,
              slave_id: slave_id,
              contact_name: contact_name
            });
          }
        });
      } else {
        this.selection.push({
          master_id: master_id,
          slave_id: slave_id,
          contact_name: contact_name
        });
      }

      this.$emit("update-accepted-id", this.selection);
      this.popupActive = false;
      // this.chosen = this.contactDescription.contact_name;
      // this.$refs.suggestComponent.input.value = "";
    },
    rejectMatch(master_id, slave_id, contact_name) {
      this.selection.filter(ele => ele.slave_id != slave_id);
      // this.selection.pop({
      //   master_id: master_id,
      //   slave_id: slave_id,
      //   company_name : company_name
      // });
      // console.log(this.selection);
      this.chosen = null;
      this.$emit("update-rejected-id", this.selection);
      this.$refs.suggestComponent.input.value = "";
      this.popupActive = false;
    },
    onSuggestSelect(suggest) {
      this.selected = suggest;
      let master_slave_id = {};
      master_slave_id.master_id = suggest.id;
      master_slave_id.slave_id = this.selectedSlave;
      master_slave_id.campaignId = this.campaignId;

      axios
        .post(
          this.$base_url + "/api/contacts/master_slave_contacts",
          master_slave_id
        )
        .then(response => {
          this.contactDescription = response.data;
          // console.log(this.contactDescription);
          this.popupActive = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [""];
      return result.replace(
        new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
        "$1<b>$2</b>$3"
      );
    },
    getList(inputValue) {
      return this.$store
        .dispatch("contactsManagement/getContact", inputValue)
        .then(response => {
          if (response) {
            let data = moduleContactsManagement.state.contact_or_company;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].contact_id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].contact_forename +
                    " - " +
                    data[property].contact_surname
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {},
  components: {
    VueSimpleSuggest,
    Prism,
    axios
  },
  created() {
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";
// .vs-checkbox--input{
//   position: relative;
// }

.fixedButtons {
  position: fixed;
  background: white;
  z-index: 1;
  width: 100%;
  justify-content: center !important;
}

.keyText {
  font-weight: 600;
}

.vuesax-app-is-ltr .vs-list--slot {
  margin-left: auto;
  width: 500px;
}

.vue-simple-suggest.designed .suggestions .suggest-item.selected {
  background-color: white !important;
}

.vue-simple-suggest.designed,
.vue-simple-suggest.designed * {
  color: black;
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
  background-color: #f5f5f5 !important;
}

.con-vs-popup .vs-popup {
  width: 900px;
}

.detailPopUp {
  width: 100%;
  margin: 10px;
  padding-left: 40px;
  padding-top: 45px;
}

.detailPopUp .vs-list--item {
  padding: 10px;
}

.con-vs-popup .vs-popup--content {
  height: 100%;
}
</style>
